import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate0_8x.svg'

export const IconPlaybackRate0_8x = IconSVG as IconComponent
